var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/internal/DisplayIcon/OmpIcon.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@zillow/constellation';
import { DisplayIcon } from './DisplayIcon';
var StyledDisplayIcon = styled(DisplayIcon).withConfig({
  displayName: "OmpIcon__StyledDisplayIcon",
  componentId: "sc-1opoii8-0"
})(["width:100%;height:100%;"]);

var OmpIcon = function OmpIcon(_ref) {
  var icon = _ref.icon,
      iconFontColor = _ref.iconFontColor,
      imageAlt = _ref.imageAlt,
      imageSrc = _ref.imageSrc,
      imageSize = _ref.imageSize;

  if (imageSrc) {
    return /*#__PURE__*/React.createElement(Icon, {
      size: imageSize,
      className: "omp_display_image",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("img", {
      alt: imageAlt,
      src: imageSrc,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 17
      }
    }));
  }

  if (icon) {
    return /*#__PURE__*/React.createElement(StyledDisplayIcon, {
      icon: icon,
      fontColor: iconFontColor,
      className: "omp_display_icon",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 13
      }
    });
  }

  return null;
};

OmpIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Icon used in your messaging.
   * Check supported icons listed in http://constellation.pages.zgtools.net/constellation-site/team-api.html#/%40zillow%2Fzrs-cms-messaging/Components?id=displayicon
   *
   * Default icon is a zillow logo.
   * */
  icon: PropTypes.string,

  /**
   * The constellation color code for the icon's drawing color.
   * Available constellation color codes could be found at
   * http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#section-colors
   */
  iconFontColor: PropTypes.string,

  /**
   * The alt text of the image.
   */
  imageAlt: PropTypes.string,

  /**
   * The url of the image. This is used as an alternative to icon.
   */
  imageSrc: PropTypes.string,

  /**
   * The size of the icon. 'xs', 'sm', 'md', 'lg'.
   */
  imageSize: PropTypes.string
} : {};
OmpIcon.defaultProps = {
  icon: null,
  iconFontColor: null,
  imageAlt: null,
  imageSrc: null,
  imageSize: null
};
export default OmpIcon;